// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__snPro_c8d43d', '__snPro_Fallback_c8d43d'"},"className":"__className_c8d43d","variable":"__variable_c8d43d"};